import { render } from "./AppSidebar.vue?vue&type=template&id=0f00df0e&scoped=true&ts=true"
import script from "./AppSidebar.vue?vue&type=script&lang=ts"
export * from "./AppSidebar.vue?vue&type=script&lang=ts"

import "./AppSidebar.vue?vue&type=style&index=0&id=0f00df0e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f00df0e"]])

export default __exports__